// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2":"615dd4c8cea2ffaf4d8f","112":"19d6b81c5cd4fa4b8501","341":"615dd4c8cea2ffaf4d8f","446":"19d6b81c5cd4fa4b8501"}[chunkId] + ".css";
};